import { PDP_MAIN_IMAGE } from '../specs/testIds';

// Remembers the last hero src that painted so fallbacks can re-show it instead
// of a shimmer (CON-8543). Module scope, not a ref, so it survives remounts and
// re-suspensions. Keyed by pathname because the Suspense fallback renders
// outside PDPContext.Provider, where usePdpId() is null.
let lastPainted = null;

const currentKey = () =>
  typeof window === 'undefined' ? null : window.location.pathname;

export const rememberPaintedHero = src => {
  const key = currentKey();
  if (!key || !src) {
    return;
  }
  lastPainted = { key, src };
};

// Falls back to the hero currently in the DOM, for suspensions that land
// before the hero's onLoad has fired.
const heroSrcFromDom = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  const img = document.querySelector(`img[data-testid="${PDP_MAIN_IMAGE}"]`);
  const src = img?.currentSrc || img?.src || null;

  if (src) {
    // cache it, the subtree is detached by the time the fallback renders
    const key = currentKey();
    if (key) {
      lastPainted = { key, src };
    }
  }

  return src;
};

export const getPaintedHero = () => {
  const key = currentKey();

  if (lastPainted && key && lastPainted.key === key) {
    return lastPainted.src;
  }

  return heroSrcFromDom();
};

export const forgetPaintedHero = () => {
  lastPainted = null;
};

export default getPaintedHero;
